import { render, staticRenderFns } from "./CompanyHome.vue?vue&type=template&id=212ce098&scoped=true"
import script from "./CompanyHome.vue?vue&type=script&lang=js"
export * from "./CompanyHome.vue?vue&type=script&lang=js"
import style0 from "./CompanyHome.vue?vue&type=style&index=0&id=212ce098&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212ce098",
  null
  
)

export default component.exports